import api from './api';

/**
 * POST /api/ratings
 * Submit a star rating for a completed appointment.
 * @param {Object} payload - { appointmentId, rating (1-5), comment? }
 */
export const submitRating = async ({ appointmentId, rating, comment }) => {
  const { data } = await api.post('/ratings', {
    appointmentId,
    rating,
    comment: comment?.trim() || null,
  });
  return data;
};

/**
 * GET /api/ratings/appointment/:appointmentId
 * Returns existing rating or null if not yet rated.
 */
export const getRatingForAppointment = async (appointmentId) => {
  const response = await api.get(`/ratings/appointment/${appointmentId}`);
  // Axios resolves 2xx responses (including 204) without throwing,
  // so a "not yet rated" appointment must be detected via status, not catch.
  if (response.status === 204) return null;
  return response.data; // { id, appointmentId, doctorId, rating, comment, createdAt }
};

/**
 * GET /api/consultations/doctors/top-rated?limit=3
 * Returns top 3 doctors by rating.
 */
export const getTopRatedDoctors = async (limit = 3) => {
  const { data } = await api.get('/consultations/doctors/top-rated', {
    params: { limit },
  });
  return data || [];
};